import * as taskName from './task-name'
import { createValidationMessage } from '../../../../validation/create-validation-message'

import { createUIDefinition } from '../default-task-definition'
import { selectProcessContext } from '../../../state/instance-detail/selector'
import * as processUI from '../../process-ui'
import * as processAction from '../../process-action'


export default createUIDefinition({
    taskName: taskName.SHIP_RETAINER_EXTERNAL,
    overwriteWidget: true,
    widgetList: [
        {
            component: processUI.OVERVIEW,
        },
        {
            component: processUI.SUPPLIER_TRACKING_NUMBER_WIDGET,
        },
    ],
    actionList: [
        {
            action: processAction.TREATMENT_QUOTATION,
            taskPath: ['objectDetail'],
        },
    ],
    taskValidatorSelector: [
        selectProcessContext,
    ],
    taskValidator: (task, processInstance, taskName, eventName, context) => {
        const messageList = []

        const trackingNumber = context.supplierTrackingNumber
        if (!trackingNumber) {
            messageList.push(createValidationMessage('Please add the tracking number before proceeding.', 'checkDeliveryTracking.checkDeliveryTracking'))
        }

        return messageList
    },
})



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/retainer/ship-retainer-external.js